import { Injectable } from "@angular/core";
import { DataService } from "./data.service";
import { Observer, Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable()
export class DataEntryService {
  constructor(private dataService: DataService) {
  }
  url = environment.api_base_url;

  books$: Observable<any> = new Observable();
  errorMsg: string = "";

  getData(search: string, pageNumber: number): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.dataService.get(this.url).subscribe((result) => {
        observer.next(result);
        observer.complete();
      },
        (error: Array<any>) => {
          observer.error(error);
          observer.complete();
        });
    });
  }
}